import { Component, Input, OnInit } from '@angular/core';
import { CommonComponent } from '@components/common.component';
import type { Event } from '@models/community/event.model';
import { JsonPipe, NgClass, NgIf } from '@angular/common';
import moment from 'moment/moment';
import { CalendarEventDetailsComponent } from '@calendar/components/calendar-event-details/calendar-event-details.component';
import { CustomEventComponent } from '@calendar/components/custom-event/custom-event.component';
import { RouterLink } from '@angular/router';
import { AttendeePipe } from '@calendar/pipes/attendee.pipe';
import { eventsActions } from '@redux/events.effects';
import { ofType } from '@ngrx/effects';

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [NgIf, NgClass, RouterLink, AttendeePipe, JsonPipe],
  templateUrl: './event-card.component.html',
  styles: ``,
})
export class EventCardComponent extends CommonComponent implements OnInit {
  @Input() event!: Event;
  @Input() type: 'COMMUNITY' | 'USER' = 'COMMUNITY';
  @Input() details = true;
  @Input() truncate = true;
  @Input() colImage = 'col-auto';
  protected readonly mm = moment;

  ngOnInit(): void {
    this.subscriptions.push(
      this.actions$.pipe(ofType(eventsActions.updateEventFail)).subscribe(({ error }) => {
        this.notificationService.error(error);
      }),
    );
  }

  onDetails(event: Event) {
    const initialState = { data: event, type: this.type };
    this.modal.show(CalendarEventDetailsComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered',
    });
  }

  onManage(event: Event) {
    const initialState = { data: event, type: this.type };
    this.modal.show(CustomEventComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered',
    });
  }

  onAttend(event: Event) {
    if (event.entityName === 'CommunityEvent') {
      this.store.dispatch(eventsActions.attend({ event }));
    } else if (event.entityName === 'UserEvent') {
      this.store.dispatch(
        eventsActions.invite({ user: this.resident!.id, events: [event.eventId || event.id] }),
      );
    }
    this.modal.hide();
  }

  onUnAttend(event: Event) {
    if (event.rsvpLimit) {
      this.onUnRsvp(event);
    } else {
      if (event.entityName === 'CommunityEvent') {
        this.store.dispatch(eventsActions.unAttend({ event }));
      } else if (event.entityName === 'UserEvent') {
        this.store.dispatch(eventsActions.unInvite({ userIds: [this.resident!.id], event }));
      }
    }
    //
    this.modal.hide();
  }

  onRsvp(event: Event) {
    this.store.dispatch(eventsActions.rsvp({ event, listType: 'RSVP_LIST' }));
  }

  onUnRsvp(event: Event) {
    this.store.dispatch(eventsActions.unRsvp({ event, listType: 'RSVP_LIST' }));
  }

  onWaitlist(event: Event) {
    this.store.dispatch(eventsActions.rsvp({ event, listType: 'WAIT_LIST' }));
  }

  onUnWaitlist(event: Event) {
    this.store.dispatch(eventsActions.unRsvp({ event, listType: 'WAIT_LIST' }));
  }
}
